export const formatDateTime = dateTimeStr => {
  const dateObj = new Date(dateTimeStr);
  return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
};
